import api from "./axiosInterceptor";

export const connectFreshBooks = ({ code }) =>
  api.get(`/apps/freshbook/callback?code=${code}`);

export const getFreshBooksBusiness = () =>
  api.get(`/apps/freshbook/businesses`);

export const fetchFreshBooksDetails = ({ account_id, object_type }) =>
  api.get(`/apps/freshbook/accounts/${object_type}/${account_id}`);
